import { render, staticRenderFns } from "./presenceDots.vue?vue&type=template&id=4b06084a&scoped=true"
import script from "./presenceDots.vue?vue&type=script&lang=ts"
export * from "./presenceDots.vue?vue&type=script&lang=ts"
import style0 from "./presenceDots.vue?vue&type=style&index=0&id=4b06084a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b06084a",
  null
  
)

export default component.exports